export default "__VITE_ASSET__xtcK3VzI__"